
import { URLS } from '../constants'
import {
    GET_ALL_PLANS_BEGIN, GET_ALL_PLANS_SUCCESS, GET_ALL_PLANS_FAILURE,
    GET_PLAN_BEGIN, GET_PLAN_SUCCESS, GET_PLAN_FAILURE,
    POST_PLAN_BEGIN, POST_PLAN_SUCCESS, POST_PLAN_FAILURE,
    PUT_PLAN_BEGIN, PUT_PLAN_SUCCESS, PUT_PLAN_FAILURE,
    DELETE_PLAN_BEGIN, DELETE_PLAN_SUCCESS, DELETE_PLAN_FAILURE
} from '../constants/ActionTypes'

import { dispatchFetchGet, dispatchFetchPost, dispatchFetchPut, dispatchFetchDelete } from './ActionUtil'

// Get All Plans
const acGetAllPlansBegin = () => ({ type: GET_ALL_PLANS_BEGIN })
const acGetAllPlansSuccess = data => ({ type: GET_ALL_PLANS_SUCCESS, payload: data })
const acGetAllPlansFailure = err => ({ type: GET_ALL_PLANS_FAILURE, payload: err })

/**
 * @description Retrieves all plans from the server.
 *
 * @author Maria Eduarda Franke
 */
export const acGetAllPlans = () => {
    return dispatchFetchGet(
        URLS.PLANS,
        acGetAllPlansBegin,
        acGetAllPlansSuccess,
        acGetAllPlansFailure
    )
}

// Get Plan
const acGetPlanBegin = () => ({ type: GET_PLAN_BEGIN })
const acGetPlanSuccess = data => ({ type: GET_PLAN_SUCCESS, payload: data })
const acGetPlanFailure = err => ({ type: GET_PLAN_FAILURE, payload: err })

/**
 * @description Dispatches a GET request to retrieve a plan.
 *
 * @author Maria Eduarda Franke
 */
export const acGetPlan = planId => {
    return dispatchFetchGet(
        `${URLS.PLANS}/${planId}`,
        acGetPlanBegin,
        acGetPlanSuccess,
        acGetPlanFailure
    )
}

// Post Plan
const acPostPlanBegin = () => ({ type: POST_PLAN_BEGIN })
const acPostPlanSuccess = data => ({ type: POST_PLAN_SUCCESS, payload: data })
const acPostPlanFailure = err => ({ type: POST_PLAN_FAILURE, payload: err })

/**
 * @description Dispatches a POST request to create a plan.
 *
 * @author Maria Eduarda Franke
 */
export const acPostPlan = plan => {
    return dispatchFetchPost(
        URLS.PLANS,
        { ...plan },
        acPostPlanBegin,
        acPostPlanSuccess,
        acPostPlanFailure
    )
}

// Put Plan
const acPutPlanBegin = () => ({ type: PUT_PLAN_BEGIN })
const acPutPlanSuccess = data => ({ type: PUT_PLAN_SUCCESS, payload: data })
const acPutPlanFailure = err => ({ type: PUT_PLAN_FAILURE, payload: err })

/**
 * @description Dispatches a PUT request to update a plan.
 *
 * @author Maria Eduarda Franke
 */
export const acPutPlan = (planId, plan) => {
    return dispatchFetchPut(
        `${URLS.PLANS}/${planId}`,
        { ...plan },
        acPutPlanBegin,
        acPutPlanSuccess,
        acPutPlanFailure
    )
}

// Delete Plan
const acDeletePlanBegin = () => ({ type: DELETE_PLAN_BEGIN })
const acDeletePlanSuccess = data => ({ type: DELETE_PLAN_SUCCESS, payload: data })
const acDeletePlanFailure = err => ({ type: DELETE_PLAN_FAILURE, payload: err })

/**
 * @description Dispatches a DELETE request to delete a plan.
 *
 * @author Maria Eduarda Franke
 */
export const acDeletePlan = planId => {
    return dispatchFetchDelete(
        `${URLS.PLANS}/${planId}`,
        acDeletePlanBegin,
        acDeletePlanSuccess,
        acDeletePlanFailure
    )
}